/* @pareto-engineering/generator-front 1.0.12 */
import { urljoin as _u } from 'utils'

export const opsBasePath = '/outsourced-operations'
export const basePath = '/'

export default {
  HOME        :basePath,
  CAREERS     :_u(basePath, 'careers'),
  AI_TRAINER  :_u(basePath, 'careers', 'ai-trainer'),
  OPS_HOME    :opsBasePath,
  HOW_IT_WORKS:_u(opsBasePath, 'how-it-works'),
  PRICING     :_u(opsBasePath, 'pricing'),
}
